import HomeIcon from "@mui/icons-material/Home";
import LanguageIcon from "@mui/icons-material/Language";
import NotificationsIcon from "@mui/icons-material/Notifications";
import RepeatIcon from "@mui/icons-material/Repeat";
import SummarizeIcon from "@mui/icons-material/Summarize";
import SettingsIcon from "@mui/icons-material/Settings";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import KeyIcon from "@mui/icons-material/Key";

export const MainMenu = {
  modules: [
    {
      id: "Overview",
      icon: <HomeIcon fontSize="small" />,
      name: "Overview",
      path: "/",
    },
    {
      id: "SWIFT",
      icon: <LanguageIcon fontSize="small" />,
      name: "SWIFT",
      path: "/swift-day",
    },
    {
      id: "Alerts&Notifications",
      icon: <NotificationsIcon fontSize="small" />,
      name: "Alerts&Notifications",
      path: "/internal-alerts",
    },
    {
      id: "Matching",
      icon: <RepeatIcon fontSize="small" />,
      name: "Matching",
      path: "/matching-rules",
    },
    {
      id: "Reporting",
      icon: <SummarizeIcon fontSize="small" />,
      name: "Reporting",
      path: "/reports",
    },
  ],
  settings: [
    {
      id: "Admin Tool",
      icon: <SettingsIcon fontSize="small" />,
      name: "Admin Tool",
      nestedList: [
        {
          id: "Bank Settings",
          name: "Bank Settings",
          path: "admin-tool/bank-settings",
        },
        {
          id: "Alerts & Notifications",
          name: "Alerts & Notifications",
          path: "admin-tool/alerts-notifications",
        },
        {
          id: "Search & Archive",
          name: "Search & Archive",
          path: "admin-tool/search-archive",
        },
      ],
    },
    {
      id: "User Management",
      icon: <AccountBoxIcon fontSize="small" />,
      name: "User Management",
      nestedList: [
        {
          id: "Users",
          name: "Users",
          path: "user-management/users",
        },
      ],
    },
    {
      id: "License",
      icon: <KeyIcon fontSize="small" />,
      name: "License",
      path: "/license",
    },
  ],
};

export const SwiftMenu = [
  {
    id: "SWIFT Day",
    name: "SWIFT Day",
    path: "/swift-day",
  },
  {
    id: "swiftMessages",
    name: "Search Swift Message",
    path: "/swift-search",
  },
];
export const SwiftRoutes = ["/swift-day", "/swift-search"];

export const AlertsMenu = [
  {
    id: "Alerts Settings",
    name: "Alerts Settings",
    path: "/alerts-settings",
  },
  {
    id: "Following on Internal Alerts",
    name: "Following on Internal Alerts",
    path: "/internal-alerts",
  },
];
export const AlertsRoutes = ["/alerts-settings", "/internal-alerts"];

export const MatchingMenu = [
  {
    id: "Matching Rules",
    name: "Matching Rules",
    path: "/matching-rules",
  },
  {
    id: "Matching Day",
    name: "Mathcing Day",
    path: "/matching-day",
  },
];
export const MatchingRoutes = ["/matching-day", "/matching-rules"];

export const AdminToolMenu = [
  {
    id: "Bank Settings",
    name: "Bank Settings",
    path: "/admin-tool/bank-settings",
  },
  {
    id: "Alerts & Notifications",
    name: "Alerts & Notifications",
    path: "/admin-tool/alerts-notifications",
  },
  {
    id: "Search & Archive",
    name: "Search & Archive",
    path: "/admin-tool/search-archive",
  },
];
export const AdminToolRoutes = [
  "/admin-tool/bank-settings",
  "/admin-tool/alerts-notifications",
  "/admin-tool/search-archive",
];

export const UserManagementMenu = [
  {
    id: "Users",
    name: "Users",
    path: "/user-management/users",
  },
];
export const UserManagementRoutes = ["/user-management/users"];
